/* eslint-disable */
// @ts-nocheck
!(function () {
  if (typeof window === 'undefined') {
    return
  }
  for (
    var e,
      t,
      n = window.location.host,
      i = {
        callbacks: {},
        send: function (e, t) {
          this.dispatchMessage('event', e, t)
        },
        sendCallback: function (e, t) {
          var n = s.createEnvelope(e, 'return', { returnStr: t })
          this.dispatchMessage('callback', n, function () {})
        },
        triggerCallback: function (e, t) {
          var n = this
          setTimeout(function () {
            n.callbacks[e](t)
          }, 0)
        },
        dispatchMessage: function (e, t, n) {
          var i, s
          ;(this.callbacks[t.id] = function (e) {
            n(e)
          }),
            (i = 'jockey://' + e + '/' + t.id + '?' + encodeURIComponent(JSON.stringify(t))),
            (s = document.createElement('iframe')),
            s.setAttribute('src', i),
            document.documentElement.appendChild(s),
            s.parentNode.removeChild(s),
            (s = null)
        },
      },
      s = {
        listeners: {},
        dispatcher: null,
        messageCount: 0,
        on: function (e, t) {
          ;(!this.listeners.hasOwnProperty(e) || !(this.listeners[e] instanceof Array)) &&
            (this.listeners[e] = []),
            this.listeners[e].push(t)
        },
        off: function (e, cb) {
          // 兼容老逻辑
          if (!cb) {
            ;(!this.listeners.hasOwnProperty(e) || !(this.listeners[e] instanceof Array)) &&
              (this.listeners[e] = []),
              (this.listeners[e] = [])
          } else {
            if (this.listeners[e] && this.listeners[e].length > 0) {
              const index = this.listeners[e].findIndex((_) => _ === cb)
              index != -1 && this.listeners[e].splice(index, 1)
            }
          }
        },
        send: function (e, t, n) {
          t instanceof Function && ((n = t), (t = null)), (t = t || {}), (n = n || function () {})
          var i = this.createEnvelope(this.messageCount, e, t)
          this.dispatcher.send(i, n), (this.messageCount += 1)
        },
        trigger: function (e, t, n) {
          var i,
            s,
            r = this,
            a = this.listeners[e] || [],
            o = 0,
            c = function (e) {
              ;(o += 1), o >= a.length && r.dispatcher.sendCallback(t, e)
            }
          for (i = 0; i < a.length; i++) (s = a[i]), s.length <= 1 ? (s(n), c()) : s(n, c)
        },
        triggerCallback: function (e, t) {
          this.dispatcher.triggerCallback(e, t)
        },
        createEnvelope: function (e, t, i, s) {
          return { id: e, type: t, host: n, payload: i, returnStr: s }
        },
        createCallbackEnvelope: function (e, t) {
          return { id: e, returnStr: t }
        },
      },
      r = {
        send: function (e, t) {
          t()
        },
        triggerCallback: function () {},
        sendCallback: function () {},
      },
      a = 0,
      o = !1,
      c = ['iPad', 'iPhone', 'iPod'];
    a < c.length;
    a++
  )
    if (navigator.platform.indexOf(c[a]) >= 0) {
      o = !0
      break
    }
  ;(e = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent)),
    (t = navigator.userAgent.toLowerCase().indexOf('android') > -1),
    (s.dispatcher = (o && e) || t ? i : r),
    (window.Jockey = s)
})()
export {}
